import type { FaireProductEntity } from "../../entity_types/product";

export const p_wfpuu64s8d: FaireProductEntity = {
  token: "p_wfpuu64s8d",
  type: "product",
  name: "LOW WAIST DENIM CAPRI PANTS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/2268e75f9208a5877c6255709f55231a6facd6d35ee16a199c0136a292c14b77.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f19df6efc2b5d49b30bc83dae0e938ef69b5607cfd284625fcc69d32fba4059f.jpeg",
    "https://cdn.faire.com/fastly/de82f948e2e0140a37d260fa279ca35b13ea8348c9c01720c918917b7e247389.jpeg",
    "https://cdn.faire.com/fastly/04cebd9831cd5afc71cdc06ce3aee70c142f6cecf7b8e0caa311ebace5a3b5aa.jpeg",
    "https://cdn.faire.com/fastly/64037aa4eefe73608d8ff9edca1e7843cc215768b811c75f8eaf2992ff608dea.jpeg",
    "https://cdn.faire.com/fastly/f2df63267cd16855bf412a65e1896b003276ef26773c33e169fb74b7f100ce78.jpeg",
  ],
  priceDollars: 186,
  description:
    '**PANTS ONLY**\n\n(MATCHING SET WITH: SJ3810)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 372,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:17.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
